import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-package-token-screen',
    templateUrl: './package-token-screen.component.html',
    styleUrls: ['./package-token-screen.component.scss'],
    standalone: false
})
export class PackageTokenScreenComponent implements OnInit, AfterViewInit, OnDestroy {
  data: any;
  list: any;
  screen_number: any;
  haSubscription: Subscription;
  fullscreen: any = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false };

  constructor(
    private baseService: BaseService,
    private Aroute: ActivatedRoute,
    private alert: AlertsService,
    private route: Router,
    public utilService: UtilService,
    private communicationService: CommunicationService
  ) { }

  ngOnInit(): void {
    this.baseService.get("GET_PAGE", "", "screen_master", "facility-management", "screen_number:" + decodeURIComponent(this.Aroute.snapshot.params.id)).subscribe((res: any) => {
      if (res.errCode == 0) {
        if (res.resource.length == 0) {
          this.alert.error("Error in getting data !!!")
        } else {
          this.screen_number = res.resource[0].screen_number;
          this.getList$(res.resource[0].patient_per_queue);
          this.baseService.setTitle("field.label.token_management_screen");
          const source = interval(JSON.parse(res.resource[0].refresh_rate == undefined ? "30" : res.resource[0].refresh_rate) * 1000);
          this.haSubscription = source.subscribe(val => this.getList$(res.resource[0].patient_per_queue));
        }
      } else {
        this.alert.error(res.message)
      }
    })
  }

  ngAfterViewInit() {
    this.checkSidebarOpen()
    setTimeout(function () {
      // let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
      // hideSidebar.style.display = "none"
      let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
      hasDisplay.style.display = "none"
    }, 5)
  }

  checkSidebarOpen() {
    this.communicationService.emitSidebar({ sidebar: false });
  }

  getList$(limit: any) {
    this.baseService.get("GET_BY_SCREEN", "screen_number:" + decodeURIComponent(this.Aroute.snapshot.params.id) + ",token_limit:" + limit, "queue_desk", "queue-management").subscribe((response: any) => {
      if (response.errCode == 0) {
        let temp1 = response.resource;
        let temp2 = []
        temp1.map(x => x.queueDeskMapping).forEach((elem: any) => {
          if (elem && elem.length != 0) {
            temp2.push(elem.filter(y => y.stage != "No Show"))
          }
        })
        temp2.forEach(elem => {
          if (elem.length > 1) {
            elem.forEach((data: any, index: any) => {
              elem[0]['next_token'] = elem[1].token;
              if (elem[2] && elem[2].token)
                elem[0]['second_token'] = elem[2].token
            })
          }
        })
        this.list = [].concat.apply([], [].concat.apply([], temp2).map(q => q.phc_desk_data_list)).filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t && thing ? t.service_item === thing.service_item: false
          ))).sort(function (a, b) { return a.sequence - b.sequence })

        var temp3 = [].concat.apply([], temp2).filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.desk_id === thing.desk_id && t.desk_name === thing.desk_name
          )))
        this.list.map(function (x) {
          if (temp3.filter(z => (z.desk_type == x.desk_type && z.service_item == x.serviceItemName)).length != 0) {
            x['ballentine'] = true
          } else {
            x['ballentine'] = false
          }
        })
        this.data = temp3;
        console.log("thisdgaajkjk ", this.data);
        console.log("thisdgaajkjk list", this.list);
      } else {
        this.alert.error(response.message)
      }
    })
  }

  checkCondition(q: any) {
    console.log("q is :: ", q)
    return Object.keys(q).length == 0 ? true : false
  }

  backToTVScreen() {
    this.route.navigate([this.Aroute.snapshot.queryParams.returnUrl])
  }

  switchFullscreen(i) {
    this.fullscreen[i] = true;
  }

  ngOnDestroy() {
    this.haSubscription.unsubscribe();
    let showbody: HTMLElement = document.getElementsByTagName("body")[0] as HTMLElement
    showbody.style.backgroundImage = "";
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = null;
    hasColor.style.width = null;
    let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    hasDisplay.style.display = "block";
    this.communicationService.emitSidebar({ sidebar: true });
  }

}
